import { Component, Vue, Prop } from 'vue-property-decorator';
import QuestionnaireService from '@/services/questionnaire.service';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import InsuranceAutoComplete from '@/components/inputs/InsuranceAutoComplete/InsuranceAutoComplete.vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputMaskedText from '@/components/inputs/InputMaskedText/InputMaskedText.vue';
import StepStatus from '@/components/StepStatus/StepStatus.vue';
import RenounceButton from '@/components/RenounceButton/RenounceButton.vue';

@Component({
  components: {
    InsuranceAutoComplete,
    InputText,
    InputCheckbox,
    InputMaskedText,
    StepStatus,
    RenounceButton,
  },
})
export default class QuestInsurance extends Vue {
  @Prop({ required: false, default: false }) public isRecap!: boolean;
  public partId: number | undefined;
  public questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;
  public avsError: boolean = false;

  /**
   * Get an array of all the property names from the questionnaire data in lowercase
   */
  get instanceFields(): string[] {
    if (this.$store.state.questionnaire.insurance) {
      let fields: string[] = [];
      Object.keys(this.questionnaire.insurance).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }
  
  /**
   * Get the errors returned by the API corresponding to the questionnaire data properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      let errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    // this.fetchQuestionnaire(this.partId);
    this.questionnaire = this.$store.state.questionnaire;
  }

  /**
   * Fetch the questionnaire data with the service
   * @param partId The participant ID
   */
  protected fetchQuestionnaire(partId: number) {
    QuestionnaireService.fetchQuestionnaire(partId, 'insurance')
      .then((response) => {
        this.questionnaire = response as QuestionnaireDTO;
        this.$store.commit('setQuestionnaireInsurance', response.insurance)
      });
  }

  /**
   * Handles the validity of the AVS field
   * @param isMaskValid True is the field is valid (match the mask config).
   */
  protected handleFormValidation(isMaskValid: boolean): void {
    if (isMaskValid && !!this.questionnaire.insurance.avsNumber && !this.questionnaire.insurance.avsNumber.startsWith('756')) {
      this.avsError = true;
      return;
    }

    this.avsError = !isMaskValid && !!this.questionnaire.insurance.avsNumber;
  }

  protected async onSubmit(event: any) {
    await QuestionnaireService.updateQuestionnaire(this.questionnaire, 'insurance')
      .then(() => {
        this.questionnaire.insurance.isValidated = true;
        this.$store.commit('setQuestionnaireInsurance', this.questionnaire.insurance);
        if (event.submitter.id === 'btn-continue') {
          this.$router.push({
            name: 'doctor',
            params: {
              screening: this.$route.params.screening,
              partId: String(this.partId),
            },
          });
        } else {
          this.$router.push({
            name: 'overview',
            params: {
              screening: this.$route.params.screening,
              partId: String(this.partId),
            },
          });
        }
        
      });
  }
}

